let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("auWZO")).then(() => parcelRequire('3BrGv'));